(() => {
  if (window.sleepyRemoval) return;
  window.sleepyRemoval = true;
  const configNode = document.querySelector('[data-removal-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  config.variants = config.variants || [];
  let hasRemoval = !!config.requested;
  const markSelection = selected => {hasRemoval=selected;document.documentElement.classList.toggle('scr-removal-selected',selected);};
  markSelection(hasRemoval);
  const root = window.Shopify?.routes?.root || '/';
  const keys = {requested: 'Old-mattress removal', street: 'Collection street address', locality: 'Collection locality', postcode: 'Collection postcode'};
  const normal = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase().replace(/\s+/g, ' ');
  const zoneFor = locality => config.zones[normal(locality)] || null;
  const priceFor = locality => ({Base: 5000, Near: 8000, Middle: 8000, 'Outer cap': 10000})[zoneFor(locality)] || null;
  const service = item => item.handle === config.handle || item.properties?._sleepy_removal === 'v1';
  const eligible = item => config.eligibleIds.includes(Number(item.product_id));
  const money = cents => new Intl.NumberFormat('en-NZ', {style:'currency', currency:'NZD'}).format(cents / 100);
  const api = async (path, body) => {
    const response = await fetch(root + path, {method: body ? 'POST' : 'GET', headers: {'Accept': 'application/json', ...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body: JSON.stringify(body)} : {}), cache: 'no-store'});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'Unable to save your collection details. Please try again.');
    return data;
  };
  let pending = Promise.resolve();
  const attributes = values => { if (Object.hasOwn(values, keys.requested)) markSelection(!!values[keys.requested]); pending = pending.catch(() => {}).then(() => api('cart/update.js', {attributes: values})); return pending; };
  const contact = 'We cannot confidently match this locality to a covered zone. Please contact SleepyCo on 027 533 7920 before adding removal. Islands are unavailable.';
  const readAddress = container => Object.fromEntries(['street','locality','postcode'].map(key => [key, container.querySelector(`[data-removal-${key}]`)?.value.trim() || '']));
  const validAddress = container => {
    const address = readAddress(container);
    const street = container.querySelector('[data-removal-street]');
    const locality = container.querySelector('[data-removal-locality]');
    const postcode = container.querySelector('[data-removal-postcode]');
    street.setCustomValidity(address.street.length >= 5 ? '' : 'Enter the full street address, including street number and any unit.');
    locality.setCustomValidity(zoneFor(address.locality) ? '' : contact);
    postcode.setCustomValidity(/^\d{4}$/.test(address.postcode) ? '' : 'Enter a four-digit New Zealand postcode.');
    return [street, locality, postcode].every(field => field.reportValidity()) && !!priceFor(address.locality);
  };
  const showError = (container, error) => { const output = container.querySelector('[data-removal-status]'); output.textContent = error.message || String(error); output.setAttribute('role','alert'); };
  const revealPrice = container => {
    if (!window.matchMedia?.('(max-width: 767px)').matches) return;
    const output = container.querySelector('[data-removal-status]');
    requestAnimationFrame(() => output.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center'
    }));
  };
  const quote = container => {
    if (!validAddress(container)) { container.querySelector('[data-removal-status]').textContent = contact; return false; }
    const address = readAddress(container);
    const zone = zoneFor(address.locality);
    container.dataset.quote = JSON.stringify(address);
    container.querySelector('[data-removal-status]').textContent = `${money(priceFor(address.locality))} incl. GST for one old mattress — ${zone} zone. Outdoor collection only. We’ll confirm collection arrangements.`;
    revealPrice(container);
    return true;
  };
  const initProduct = card => {
    if (card.dataset.ready) return;
    card.dataset.ready = 'true';
    const checkbox = card.querySelector('[data-removal-select]');
    const details = card.querySelector('[data-removal-address-wrap]');
    const form = document.getElementById(card.dataset.form);
    const setSelected = async () => {
      details.hidden = !checkbox.checked;
      delete card.dataset.quote;
      card.querySelector('[data-removal-status]').textContent = '';
      try {
        await attributes({[keys.requested]: checkbox.checked ? 'Requested' : '', ...(!checkbox.checked ? {[keys.street]:'',[keys.locality]:'',[keys.postcode]:''} : {})});
        if (!checkbox.checked) {
          const cart = await api('cart.js');
          const updates = Object.fromEntries(cart.items.filter(service).map(item => [item.key, 0]));
          if (Object.keys(updates).length) await api('cart/update.js', {updates});
        }
      } catch (error) { showError(card, error); }
    };
    checkbox.addEventListener('change', setSelected);
    card.querySelector('[data-removal-check]').addEventListener('click', async () => {
      if (!quote(card)) return;
      const address = readAddress(card);
      try { await attributes({[keys.requested]:'Requested',[keys.street]:address.street,[keys.locality]:address.locality,[keys.postcode]:address.postcode}); }
      catch (error) { delete card.dataset.quote; showError(card,error); }
    });
    details.addEventListener('input', event => {
      event.target.setCustomValidity?.('');
      delete card.dataset.quote;
      card.querySelector('[data-removal-status]').textContent = 'Check the price again after changing the address.';
    });
    if (form) form.dataset.removalForm = card.id;
  };
  const productCard = form => form && document.getElementById(form.dataset.removalForm);
  const productReady = card => {
    if (!card?.querySelector('[data-removal-select]')?.checked) return true;
    if (card.dataset.quote !== JSON.stringify(readAddress(card))) {
      showError(card, 'Please check your collection price before adding removal.');
      card.querySelector('[data-removal-check]').focus();
      return false;
    }
    return true;
  };
  document.addEventListener('submit', event => {
    const card = productCard(event.target);
    if (card && !productReady(card)) { event.preventDefault(); event.stopImmediatePropagation(); }
    if (event.target.id==='cart' && (event.submitter?.name==='checkout' || hasRemoval)) {event.preventDefault();event.stopImmediatePropagation();if(event.submitter) event.submitter.click(); else {const booking=document.querySelector('[data-removal-booking]'); if(booking){booking.hidden=false;booking.scrollIntoView({behavior:'smooth'});booking.querySelector('input,select')?.focus();}}}
  }, true);
  document.addEventListener('click', async event => {
    const buy = event.target.closest('.sp-buy-now-button');
    if (buy) {
      const wrapper = buy.closest('sleepy-buy-now');
      const add = wrapper?.querySelector('[name="add"]');
      const form = add?.form;
      const card = productCard(form);
      if (!card?.querySelector('[data-removal-select]')?.checked && !hasRemoval) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (!productReady(card) || !form.reportValidity()) return;
      buy.disabled = true;
      try {
        await pending;
        const data = new FormData(form); data.delete('sections'); data.delete('sections_url');
        const response = await fetch(root + 'cart/add.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || 'Unable to add mattress.');
        window.location.assign(root + 'cart#sleepy-removal-booking');
      } catch(error) { showError(card,error); buy.disabled=false; }
      return;
    }
    const candidate = event.target.closest('button');
    const checkout = event.target.closest('[name="checkout"], a[href$="/checkout"], [data-removal-drawer-checkout]') || (candidate?.textContent.trim()==='Checkout' ? candidate : null);
    if (!checkout) return;
    if (checkout.closest('[data-removal-booking]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try {
      await pending;
      const cart = await api('cart.js');
      if (cart.attributes[keys.requested] || cart.items.some(service)) {
        if (location.pathname.replace(/\/$/,'').endsWith('/cart')) {
          const booking = document.querySelector('[data-removal-booking]');
          if (booking) { booking.hidden=false; booking.scrollIntoView({behavior:'smooth',block:'start'}); booking.querySelector('input,select')?.focus(); }
          else window.location.assign(root + 'cart#sleepy-removal-booking');
        } else window.location.assign(root + 'cart#sleepy-removal-booking');
      } else window.location.assign(root + 'checkout');
    } catch(error) { window.alert(error.message); }
  }, true);
  const initBooking = async booking => {
    if (booking.dataset.ready) return;
    booking.dataset.ready = 'true';
    const form = booking.querySelector('form');
    const remove = booking.querySelector('[data-removal-remove]');
    const cart = await api('cart.js');
    const existing = cart.items.filter(service);
    booking.hidden = !(cart.attributes[keys.requested] || existing.length);
    if (booking.hidden) return;
    const targetExists = cart.items.some(eligible);
    if (!targetExists) {
      const updates = Object.fromEntries(existing.map(item => [item.key,0]));
      await api('cart/update.js', {updates, attributes:{[keys.requested]:''}});
      location.replace(root + 'cart'); return;
    }
    const props = existing[0]?.properties || {};
    for (const [field,key] of Object.entries(keys)) {
      const input = booking.querySelector(`[data-removal-${field}]`);
      if (input && cart.attributes[key]) input.value = cart.attributes[key];
    }
    for (const input of form.elements) if (input.name && props[input.name]) input.value=props[input.name];
    const check = booking.querySelector('[data-removal-check]');
    check.addEventListener('click', () => quote(booking));
    booking.querySelector('[data-removal-address]').addEventListener('input', event => {
      event.target.setCustomValidity?.(''); delete booking.dataset.quote;
      booking.querySelector('[data-removal-status]').textContent = 'Check your price after changing the address.';
    });
    remove.addEventListener('click', async () => {
      remove.disabled=true;
      try {
        const current=await api('cart.js');
        const updates=Object.fromEntries(current.items.filter(service).map(item=>[item.key,0]));
        await api('cart/update.js',{updates,attributes:{[keys.requested]:'',[keys.street]:'',[keys.locality]:'',[keys.postcode]:''}});
        location.assign(root+'cart');
      } catch(error) { showError(booking,error);remove.disabled=false; }
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || !validAddress(booking)) return;
      if (booking.dataset.quote !== JSON.stringify(readAddress(booking))) { showError(booking,'Please check and confirm your collection price first.');check.focus();return; }
      const submit=form.querySelector('[type="submit"]');submit.disabled=true;
      try {
        const address=readAddress(booking), zone=zoneFor(address.locality), price=priceFor(address.locality);
        const variant=config.variants.find(item=>item.title===zone);
        if (!variant || !variant.available || variant.price !== price) throw new Error('This collection option is not available yet. Please contact SleepyCo.');
        const current=await api('cart.js');
        if (!current.items.some(eligible)) throw new Error('Add a new mattress before booking removal.');
        const properties=Object.fromEntries(new FormData(form).entries());
        delete properties.confirm;
        properties['Collection zone']=zone;
        properties['Service']='Saver outdoor collection — one old mattress';
        properties['Collection timing']='Within three days of confirmed booking; collection confirmed separately';
        properties['_sleepy_removal']='v1';
        const lines=current.items.filter(service);
        const keep=lines.find(item=>Number(item.variant_id)===Number(variant.id));
        const updates=Object.fromEntries(lines.filter(item=>item!==keep).map(item=>[item.key,0]));
        if (Object.keys(updates).length) await api('cart/update.js',{updates});
        if (keep) await api('cart/change.js',{id:keep.key,quantity:1,properties});
        else await api('cart/add.js',{items:[{id:variant.id,quantity:1,properties}]});
        await attributes({[keys.requested]:'Confirmed',[keys.street]:address.street,[keys.locality]:address.locality,[keys.postcode]:address.postcode});
        const verified=await api('cart.js');
        const services=verified.items.filter(service);
        if (services.length!==1 || services[0].quantity!==1 || !verified.items.some(eligible)) throw new Error('Your cart changed. Please review your collection booking again.');
        window.location.assign(root+'checkout');
      } catch(error) { showError(booking,error);submit.disabled=false; }
    });
  };
  const init = () => {
    document.querySelectorAll('[data-removal-product]').forEach(initProduct);
    document.querySelectorAll('[data-removal-booking]').forEach(booking => initBooking(booking).catch(error=>showError(booking,error)));
    document.querySelectorAll('a[href$="/checkout"]').forEach(button=>button.dataset.removalDrawerCheckout='true');
  };
  init();document.addEventListener('shopify:section:load',init);
  let scheduled=false;
  new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;init();});}).observe(document.body,{childList:true,subtree:true});
})();
